/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import BackButton from '../../common/BackButton';
import DeliveryHours from '../TrackOrder/DeliveryHours';
import { determineLanguagePrefixPath } from '../../../../helpers/determineInternationalizationPath';

const styles = (theme) => ({
    container: {
        maxWidth: theme.palette.myAccount.container.maxWidth.upLarge,
        margin: '0 auto',
    },
    pageHeadingInner: {
        display: 'inline-block',
    },
    heading: {
        display: 'flex',
        fontSize: '15px',
        fontWeight: '700',
        textTransform: 'uppercase',
        marginBottom: '24px',
        paddingLeft: '24px',
    },
    trackOrderContainer: {
        display: 'flex',
        marginBottom: '15px',
        '& button': {
            marginLeft: '10px',
            marginTop: '-3px',
            color: theme.palette.common?.white,
            fontSize: '15px !important',
            padding: '6px 16px !important',
            backgroundColor: `${theme.palette.secondary?.main} !important`,
            border: `1px solid ${theme.palette.secondary?.main} !important`,
            letterSpacing: '1.5px',
        },
    },
});

const DesktopOrderHeader = ({ classes, brand }) => {
    if (brand?.code === '08F' || brand?.code === 'CAN') {
        return (
            <div className={classes.trackOrderContainer}>
                <BackButton url={determineLanguagePrefixPath('/track-order')} desktopOrderButton />
            </div>
        );
    }

    return (
        <Grid className={classes.container} container>
            <Grid className={classes.heading} item xs={6}>
                <h2 className="no-margin">Orders</h2>
            </Grid>
            <Grid className={classes.pageHeadingInner} item xs={6}>
                <DeliveryHours />
            </Grid>
        </Grid>
    );
};
DesktopOrderHeader.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
};

export default withStyles(styles)(DesktopOrderHeader);
